module.exports = __webpack_public_path__ + "img/ebm.02e3b05e.svg";